export const hero = {
  title: "The school in nature where children grow up happy and secure",
  subtitle: "A school with a maximum of 80 children in Gondomar: Montessori inspiration, one teacher for every 10-12 children, three languages living together daily with English as the main one, and NEASC accreditation.",
  bookVisit: "Book a visit",
  discoverGandara: "Discover Gándara"
};
